module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa user",
      "breadcrumbs": [{
        title: 'Quản lý user',
        route: {
          name: 'user'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-lg-all"
  }, [_c('el-form', {
    ref: "editUserForm",
    attrs: {
      "model": _vm.localUser,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitUser('editUserForm')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên cửa hàng",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên cửa hàng"
    },
    model: {
      value: (_vm.localUser.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "shop_name", $$v)
      },
      expression: "localUser.shop_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Họ tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Họ tên"
    },
    model: {
      value: (_vm.localUser.name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "name", $$v)
      },
      expression: "localUser.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số điện thoại",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số điện thoại"
    },
    model: {
      value: (_vm.localUser.phone),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "phone", $$v)
      },
      expression: "localUser.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.localUser.email),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "email", $$v)
      },
      expression: "localUser.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-433404b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/EditUser.vue
// module id = 640
// module chunks = 1